angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.itemOffersWidgetController', ['$scope', 'platformWebApp.bladeNavigationService', 'virtoCommerce.marketplaceModule.webApi',
        function ($scope, bladeNavigationService, marketplaceApi) {
            var blade = $scope.widget.blade;

            $scope.widget.refresh = function () {
                blade.loading = true;
                $scope.itemOffersCount = '...';
                var criteria = {
                    take: 0
                };
                if (blade.sellerProduct) {
                    criteria.sellerProductId = blade.sellerProduct.id;
                } else if (blade.currentEntityId) {
                    criteria.productId = blade.currentEntityId;
                }


                marketplaceApi.searchOffers(criteria, function (data) {
                    blade.loading = false;
                    if (data) {
                        $scope.itemOffersCount = data.totalCount;
                    }
                });
            }

            $scope.openBlade = function () {
                if (!blade.isLoading) {
                    var offersBlade = {
                        id: 'itemOffers',
                        title: 'marketplace.blades.offer-list.title',
                        controller: 'virtoCommerce.marketplaceModule.offerListController',
                        template: 'Modules/$(VirtoCommerce.MarketplaceVendor)/Scripts/blades/offer-list.tpl.html'
                    };

                    if (blade.sellerProduct) {
                        offersBlade.sellerProductId = blade.sellerProduct.id;
                    } else if (blade.currentEntityId) {
                        offersBlade.productId = blade.currentEntityId;
                    }

                    bladeNavigationService.showBlade(offersBlade, blade);
                }
            };

            $scope.widget.refresh();

        }]);
